import React from 'react';

import { SVGComponentProps } from './svg.types';

const WelcomeHelpSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M14.1667 18.9583H5.83335C2.79169 18.9583 1.04169 17.2083 1.04169 14.1666V9.99998C1.04169 6.95831 2.79169 5.20831 5.83335 5.20831H14.1667C17.2084 5.20831 18.9584 6.95831 18.9584 9.99998V14.1666C18.9584 17.2083 17.2084 18.9583 14.1667 18.9583ZM5.83335 6.45831C3.45002 6.45831 2.29169 7.61665 2.29169 9.99998V14.1666C2.29169 16.55 3.45002 17.7083 5.83335 17.7083H14.1667C16.55 17.7083 17.7084 16.55 17.7084 14.1666V9.99998C17.7084 7.61665 16.55 6.45831 14.1667 6.45831H5.83335Z"
          fill={fill}
        />
        <path
          d="M15 4.375H5C4.65833 4.375 4.375 4.09167 4.375 3.75C4.375 3.40833 4.65833 3.125 5 3.125H15C15.3417 3.125 15.625 3.40833 15.625 3.75C15.625 4.09167 15.3417 4.375 15 4.375Z"
          fill={fill}
        />
        <path
          d="M12.5 2.29169H7.5C7.15833 2.29169 6.875 2.00835 6.875 1.66669C6.875 1.32502 7.15833 1.04169 7.5 1.04169H12.5C12.8417 1.04169 13.125 1.32502 13.125 1.66669C13.125 2.00835 12.8417 2.29169 12.5 2.29169Z"
          fill={fill}
        />
        <path
          d="M12.25 11.567C12.5833 11.7594 12.5833 12.2406 12.25 12.433L9.25 14.1651C8.91667 14.3575 8.5 14.117 8.5 13.7321L8.5 10.2679C8.5 9.88305 8.91667 9.64249 9.25 9.83494L12.25 11.567Z"
          stroke={fill}
        />
      </svg>
    </span>
  );
};

export default WelcomeHelpSVG;
